import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconArrowBackLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m7.373 12.75 5.17 5.17a.706.706 0 0 1 .22.521.744.744 0 0 1-.236.532.784.784 0 0 1-.527.225.7.7 0 0 1-.527-.225l-6.34-6.34A.828.828 0 0 1 4.877 12a.827.827 0 0 1 .256-.633l6.34-6.34a.715.715 0 0 1 .514-.212.749.749 0 0 1 .54.212.735.735 0 0 1 .232.535c0 .2-.077.38-.232.534L7.373 11.25H18.75c.213 0 .391.072.535.216A.725.725 0 0 1 19.5 12a.725.725 0 0 1-.215.535.726.726 0 0 1-.535.215H7.373Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconArrowBackLine;
